import React from "react";

import { css } from "@compiled/react";
import {
    UniformSlot,
    UniformSlotWrapperComponentProps
} from "@uniformdev/canvas-react";

import { token } from "@atlaskit/tokens";

import { ContentBlock } from "@/libraries/design/components/content-block/src/content-block";
import { BgColors } from "@/libraries/design/components/link/src/link";
import {
    TabDataType,
    TabsSection
} from "@/libraries/design/patterns/tabs/src/tabs-section";

export interface UniformTabsProps {
    headerText: string;
    subHeaderText?: string;
    bgColor?: BgColors;
}

const uniformTabsContainerStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: token("space.500"),
    width: "100%",
    overflow: "hidden"
});

const UniformTabs8Col: React.FC<UniformTabsProps> = ({
    headerText,
    subHeaderText,
    bgColor = "bgWhite"
}) => {
    const renderTabs: React.ComponentType<UniformSlotWrapperComponentProps> = ({
        items
    }) => {
        const tabsData = items.map((item, index) => {
            const params =
                // @ts-ignore
                item.props?.children?.props?.data?.parameters;

            return {
                id: params?.id?.value ?? `tab-${index}`,
                title: params?.title?.value,
                tabComponent: item
            } as TabDataType;
        });

        return (
            <TabsSection
                alignment="start"
                tabsData={tabsData}
                tabSize={"small"}
                bgColor={bgColor}
            />
        );
    };

    return (
        <div css={uniformTabsContainerStyles}>
            {(headerText || subHeaderText) && (
                <ContentBlock
                    title={headerText}
                    titleAs="h2"
                    alignment="start"
                    text={subHeaderText}
                />
            )}
            <UniformSlot name="tabs" wrapperComponent={renderTabs} />
        </div>
    );
};

export default UniformTabs8Col;
